import Loader from '@components/framework/loader/Loader';
import React, {useEffect, useState} from 'react';

interface PdfViewerProps {
  file: any;
}
const PdfViewer = (Props: PdfViewerProps): React.ReactElement => {
  const {file} = Props;
  const [pdfUrl, setPdfUrl] = useState('');
  useEffect(() => {
    // Convert binary data to Blob
    const pdfBlob = new Blob([file], {type: 'application/pdf'});
    // Create URL for the Blob
    const newUrl = URL.createObjectURL(pdfBlob);
    setPdfUrl(newUrl);
    // Clean up the URL when component unmounts
    return () => URL.revokeObjectURL(newUrl);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!pdfUrl) {
    return <div><Loader /></div>;
  }
  return (
    <div>
      <iframe
        title="PDF Viewer"
        src={pdfUrl}
        style={{width: '100%', height: 'calc(100vh - 200px)', border: 'none'}}
      />
    </div>
  );
};
export default PdfViewer;
